import Image from 'app/Components/Shared/Image/image';
import React from 'react';

import {Col, Container, Row} from 'reactstrap';
import EpiContext from '@episerver/spa-core/Spa';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import Config from '../../../Config';
const BusinessCcrReportFail = () => {
  return (
    <Container fluid>
      <Image src={require('./error.svg')} />

      <div className='client-information-change-hetPay-text'>
        <Row className='justify-content-center d-flex flex-column '>
          <>
            <span className='popup-title-bold'>לקוח יקר, לא ניתן להתקדם בתהליך</span>
            <span className='popup-title'> נא פנה לאחראי\ת שירות להמשך טיפול. </span>
          </>
        </Row>
      </div>
      <Row className='justify-content-center mt-4'>
        <BtnWhite
          text={`חזרה לאיזור האישי`}
          onclick={() => {
            props.setIsShowPopup(false);
            EpiContext.navigateTo(Config.businessLobbyUrl);
          }}
        />
      </Row>
    </Container>
  );
};

export default BusinessCcrReportFail;
